import type { RotasDoModulo } from '@/app/rotas';

import {
  AnniversaryModalitiesPage,
  AnniversaryModalityFormPage,
  AnniversarySettingsPage,
  EndorsementParametersPage,
} from './AnniversaryPages';
import { BrokerProfilePage } from './BrokerProfilePage';
import { BureauQueriesPage, BureauQueryDetailPage } from './BureauQueriesPage';
import { ConsultationPage } from './ConsultationPage';
import { ModalitiesPage } from './ModalitiesPage';
import { ModalityDetailPage } from './ModalityDetailPage';
import { ParametrizationMenuPage } from './ParametrizationMenuPage';
import {
  RenewalModalitiesPage,
  RenewalModalityFormPage,
  RenewalParametersPage,
  RenewalSettingsPage,
} from './RenewalPages';

/**
 * Parametrizacao (P-PAR-1): o menu de cartoes, a lista de modalidades por ramo e
 * grupo e a configuracao da modalidade; o endosso de aniversario e a renovacao
 * (P-PAR-3).
 */
export const rotas: RotasDoModulo = {
  menu: {
    '/parametrizacao': ParametrizationMenuPage,
    '/parametrizacao/modalidades': ModalitiesPage,
    // P-PAR-3: endosso de aniversario e renovacao (parametros).
    '/parametrizacao/endosso': EndorsementParametersPage,
    '/parametrizacao/renovacao': RenewalParametersPage,
  },
  moldura: [
    {
      path: '/parametrizacao/modalidades/:modalityId',
      element: <ModalityDetailPage />,
    },
    // P-PAR-4: Perfil da Corretora, Consultas PJ e Pre-validacao e os bureaus por
    // tipo de consulta. Abrem pelos cartoes do menu, como no OnPoint.
    { path: '/parametrizacao/perfil-corretora', element: <BrokerProfilePage /> },
    { path: '/parametrizacao/consulta-pj', element: <ConsultationPage /> },
    { path: '/parametrizacao/bureaus-consulta', element: <BureauQueriesPage /> },
    {
      path: '/parametrizacao/bureaus-consulta/:queryTypeId',
      element: <BureauQueryDetailPage />,
    },
    // P-PAR-3: as telas abaixo de Endosso e Renovacao, como no OnPoint.
    {
      path: '/parametrizacao/endosso/aniversario',
      element: <AnniversarySettingsPage />,
    },
    {
      path: '/parametrizacao/endosso/aniversario/modalidades',
      element: <AnniversaryModalitiesPage />,
    },
    {
      path: '/parametrizacao/endosso/aniversario/modalidades/nova',
      element: <AnniversaryModalityFormPage />,
    },
    {
      path: '/parametrizacao/endosso/aniversario/modalidades/:settingId',
      element: <AnniversaryModalityFormPage />,
    },
    {
      path: '/parametrizacao/renovacao/configuracao',
      element: <RenewalSettingsPage />,
    },
    {
      path: '/parametrizacao/renovacao/modalidades',
      element: <RenewalModalitiesPage />,
    },
    {
      path: '/parametrizacao/renovacao/modalidades/nova',
      element: <RenewalModalityFormPage />,
    },
    {
      path: '/parametrizacao/renovacao/modalidades/:settingId',
      element: <RenewalModalityFormPage />,
    },
  ],
};
